import { ArrowLeftOutlined, ArrowUpOutlined } from "@ant-design/icons";
import {
  Upload,
  Breadcrumb,
  Button,
  Col,
  DatePicker,
  FloatButton,
  Form,
  Input,
  Row,
  Select,
  Space,
  Typography,
  theme,
  message,
} from "antd";
import React, { useCallback, useEffect, useState ,useMemo} from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Heading from "../../../components/common/heading";
import useCancelModal from "../../../lib/hooks/useCancelModal";
import { routes } from "../../../routes";
import {
  getDropDownCountry,
  getDropDownMaster,
  getDropDownVOC,
  getFutureCustomer,
} from "../../../services/customerFutures";
import { downloadFile } from "../../../services/uploadFile";
import WithSidebar from "../../../templates/withSidebar";
import { vocDataFuture } from "../../customer/touchpoint/components/dataReport";
import BehaviorView from "./components/view/behaviorView";
import ContactView from "./components/view/contactView";
import FutureDetailView from "./components/view/futureDetailView";
import VoiceOfCustomerView from "./components/view/voiceOfCustomerView";
import moment from "moment";

import axios from "axios";
import APIEndpoint from "../../../services/endpoint";
import { APPCONFIG } from "../../../Config";
import { SUCCESS_CODE} from "../../../lib/const";

const { useToken } = theme;

const { Title } = Typography;
const dateFormat = "DD/MM/YYYY";
const { RangePicker } = DatePicker;
const { Text } = Typography;
const { Option } = Select;
const { TextArea } = Input;

export const ViewFutureCustomer = () => {
  const { token } = useToken();
  const navigate = useNavigate();
  const location = useLocation();
  const [form] = Form.useForm();
  const { setOpenCancelModal, setPreviousPage } = useCancelModal();
  const [optionsYear, setOptionYear] = useState([]);
  const [actionType, setActionType] = useState(
    location.state.action_type ? location.state.action_type : ""
  );
  const [dataDetail, setDataDetail] = useState([]);
  const [id, setId] = useState(location.state.id ? location.state.id : "");

  const [dropDownCountry, setDropDownCountry] = useState([]);
  const [dropDownMaster, setDropDownMaster] = useState([]);
  const [dropDownVOC, setDropDownVOC] = useState([]);
  const [dropDownCurerntStatus, setDropDownCurerntStatus] = useState([]);
  const [dropDownCurerntStatus_v2, setDropDownCurerntStatus_v2] = useState([]);
  const [dropDownCompanyType, setDropDownCompanyType] = useState([]);
  const [dropDownIndustryType, setDropDownIndustryType] = useState([]);
  const [dropDownIndustryType_v2, setDropDownIndustryType_v2] = useState([]);
  const [dropDownAreaType, setDropDownAreaType] = useState([]);
  const [dropDownAreaType_v2, setDropDownAreaType_v2] = useState([]);
  const [dropDownRegionType, setDropDownRegionType] = useState([]);
  const [dropDownKnowChannel, setDropDownKnowChannel] = useState([]);
  const [dropDownRegionGroup, setDropDownRegionGroup] = useState([]);
  const [dropDownPurpost, setDropDownPurpost] = useState([]);

  const [dropDownproductRequirement, setDropDownProductRequirement] = useState(
    []
  );
  const [dropDowncustomerSupport, setDropDownCustomerSupport] = useState([]);
  const [dropDowncustomerExpact, setDropDownCustomerExpact] = useState([]);
  const [dropDownbusinessRequire, setDropDownbusinessRequire] = useState([]);
  const [dropDownotherProductExpect, setDropDownotherProductExpect] = useState(
    []
  );
  const [dropDownotherSupportExpect, setDropDownSupportExpect] = useState([]);
  const [dropDownotherBusinessExpect, setDropDownBusinessExpect] = useState([]);

  const [dropDownproductRequirement_v2, setDropDownProductRequirement_v2] = useState(
    []
  );
  const [dropDowncustomerSupport_v2, setDropDownCustomerSupport_v2] = useState([]);
  const [dropDowncustomerExpact_v2, setDropDownCustomerExpact_v2] = useState([]);
  const [dropDownbusinessRequire_v2, setDropDownbusinessRequire_v2] = useState([]);
  const [dropDownotherProductExpect_v2, setDropDownotherProductExpect_v2] = useState(
    []
  );
  const [dropDownotherSupportExpect_v2, setDropDownSupportExpect_v2] = useState([]);
  const [dropDownotherBusinessExpect_v2, setDropDownBusinessExpect_v2] = useState([]);



  const [productRequirement, setProductRequirement] = useState({});
  const [customerSupport, setCustomerSupport] = useState({});
  const [customerExpact, setCustomerExpact] = useState({});
  const [businessRequire, setbusinessRequire] = useState({});
  const [otherProductExpect, setotherProductExpect] = useState({});
  const [otherSupportExpect, setotherSupportExpect] = useState({});
  const [otherBusinessExpect, setotherBusinessExpect] = useState({});
  const [otherExpect, setotherExpect] = useState({});

  const [productRequirement_v2, setProductRequirement_v2] = useState({});
  const [customerSupport_v2, setCustomerSupport_v2] = useState({});
  const [customerExpact_v2, setCustomerExpact_v2] = useState({});
  const [businessRequire_v2, setbusinessRequire_v2] = useState({});
  const [otherProductExpect_v2, setotherProductExpect_v2] = useState({});
  const [otherSupportExpect_v2, setotherSupportExpect_v2] = useState({});
  const [otherBusinessExpect_v2, setotherBusinessExpect_v2] = useState({});
  const [otherExpect_v2, setotherExpect_v2] = useState({});

  const [futureCustomerContacts, setFutureCustomerContacts] = useState([]);
  const [countMonth, setCounthMonth] = useState(0);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [preview, setPreview] = useState({ visible: false, src: "", isPdf: false, title: "" });
  const [fileImageList, setFileImageList] = useState([]);


  const [fileList, setFileList] = useState([]);
  
  const onChangePage = () => {
    setOpenCancelModal(true);
  };

  const onFinish = (values) => {
    //  console.log("values : ", values);
  };

  const CalMonth = (dateString) => {
    const d_now = new Date();
    const getDate = (date) => moment(date, "DD/MM/YYYY").startOf("month");
    const diff = Math.abs(getDate(dateString).diff(getDate(d_now), "months"));

    return diff;
  };
  const [thumbs, setThumbs] = useState({});
  const slotIndex = 0; 
  const items = useMemo(
      () => (fileImageList || []).filter((x) => x.index === slotIndex),
      [fileImageList, slotIndex]
    );
  const normalizeContentType = (obj) => {
    let t = obj?.headers?.["Content-Type"] ?? obj?.headers?.["content-type"] ?? "";
    if (Array.isArray(t)) t = t[0];
    t = String(t || "").toLowerCase();
    if (!t || t === "application/octet-stream") {
      const n = (obj?.fileName || "").toLowerCase();
      if (n.endsWith(".jpg") || n.endsWith(".jpeg")) return "image/jpeg";
      if (n.endsWith(".png")) return "image/png";
      if (n.endsWith(".pdf")) return "application/pdf";
    }
    return t || "image/jpeg";
  };
  const hydrateImages = (serverList = [], slotIndex = 0) => {
    return serverList.map((it, i) => ({
      index: slotIndex,
      slot: slotIndex,
      uid: it.imagePersonalId || `${slotIndex}-${i}`,
      status: 'done',
      file: it.fileName,          
      name: it.fileName,          
      fileName: it.fileName,      
      path: it.filePath,          
      url: '',                    
    }));
  };
  useEffect(() => {
    let cancelled = false;
    (async () => {
      for (const it of items) {
        if (thumbs[it.path]) continue;  // มีแล้วข้าม
        try {
          const res = await downloadFile(it.path);
          const { objectValue } = res?.data || {};
          if (!objectValue?.bytes) continue;
          const type = normalizeContentType(objectValue);
          if (type === "application/pdf") {
            // PDF ไม่ทำรูป thumb, ให้พรีวิวตอนกดดู
            setThumbs((p) => ({ ...p, [it.path]: { src: "", isPdf: true, title: objectValue.fileName || it.fileName } }));
            continue;
          }
          const src = bytesToDataUrl(objectValue.bytes, type);
          if (!cancelled) {
            setThumbs((p) => ({ ...p, [it.path]: { src, isPdf: false, title: objectValue.fileName || it.fileName } }));
          }
        } catch {
          /* เงียบไว้ แสดง skeleton แทน */
        }
      }
    })();
    return () => { cancelled = true; };
  }, [items]);
  const getDetail = useCallback(async () => {
    const res = await getFutureCustomer(id);
    if (res.data.code === "0000") {
      let result_data = res.data.objectValue;
      setDataDetail(result_data);
      setCounthMonth(CalMonth(result_data.fromDate));

      const hydrated = hydrateImages(result_data.futureCustomerImagePersonal || [], slotIndex);
      setFutureCustomerContacts(result_data.futureCustomerContacts);
      setFileImageList(prev => {
      const others = prev.filter(x => x.index !== slotIndex);
      return [...others, ...hydrated];
      });
      form.setFields([
        { name: ['filePath', slotIndex], value: hydrated.map(x => x.path), errors: [] },
      ]);
      const product_requirement = result_data.futureCustomerVoc.filter(
        (word) => word.type === "product_requirement"
      );
      setProductRequirement(
        product_requirement.length > 0 ? product_requirement[0].detail : ""
      );

      const customer_support = result_data.futureCustomerVoc.filter(
        (word) => word.type === "customer_support"
      );
      setCustomerSupport(
        customer_support.length > 0 ? customer_support[0].detail : ""
      );

      const business_require = result_data.futureCustomerVoc.filter(
        (word) => word.type === "business_require"
      );
      setbusinessRequire(
        business_require.length > 0 ? business_require[0].detail : ""
      );

      const customer_expect = result_data.futureCustomerVoc.filter(
        (word) => word.type === "customer_expect"
      );
      setCustomerExpact(
        customer_expect.length > 0 ? customer_expect[0].detail : ""
      );

      const other_product_expect = result_data.futureCustomerVoc.filter(
        (word) => word.type === "other_product_expect"
      );
      setotherProductExpect(
        other_product_expect.length > 0 ? other_product_expect[0].detail : ""
      );

      const other_support_expect = result_data.futureCustomerVoc.filter(
        (word) => word.type === "other_support_expect"
      );
      setotherSupportExpect(
        other_support_expect.length > 0 ? other_support_expect[0].detail : ""
      );

      const other_business_expect = result_data.futureCustomerVoc.filter(
        (word) => word.type === "other_business_expect"
      );
      setotherBusinessExpect(
        other_business_expect.length > 0 ? other_business_expect[0].detail : ""
      );

      const other_expect = result_data.futureCustomerVoc.filter(
        (word) => word.type === "other_expect"
      );
      setotherExpect(other_expect.length > 0 ? other_expect[0].detail : "");
      
      //voc_v2

      const product_requirement_v2 = result_data.futureCustomerVoc.filter(
        (word) => word.type === "future_product_require"
      );
      setProductRequirement_v2(
        product_requirement.length > 0 ? product_requirement[0].detail : ""
      );

      const customer_support_v2 = result_data.futureCustomerVoc.filter(
        (word) => word.type === "future_customer_support"
      );
      setCustomerSupport_v2(
        customer_support.length > 0 ? customer_support[0].detail : ""
      );

      const business_require_v2 = result_data.futureCustomerVoc.filter(
        (word) => word.type === "future_business_require"
      );
      setbusinessRequire_v2(
        business_require.length > 0 ? business_require[0].detail : ""
      );

      const customer_expect_v2 = result_data.futureCustomerVoc.filter(
        (word) => word.type === "future_customer_expect"
      );
      setCustomerExpact_v2(
        customer_expect.length > 0 ? customer_expect[0].detail : ""
      );

      const other_product_expect_v2 = result_data.futureCustomerVoc.filter(
        (word) => word.type === "future_other_product_expect"
      );
      setotherProductExpect_v2(
        other_product_expect.length > 0 ? other_product_expect[0].detail : ""
      );

      const other_support_expect_v2 = result_data.futureCustomerVoc.filter(
        (word) => word.type === "future_other_support_expect"
      );
      setotherSupportExpect_v2(
        other_support_expect.length > 0 ? other_support_expect[0].detail : ""
      );

      const other_business_expect_v2 = result_data.futureCustomerVoc.filter(
        (word) => word.type === "future_other_business_expect"
      );
      setotherBusinessExpect_v2(
        other_business_expect.length > 0 ? other_business_expect[0].detail : ""
      );

      const other_expect_v2 = result_data.futureCustomerVoc.filter(
        (word) => word.type === "other_expect"
      );
      setotherExpect_v2(other_expect.length > 0 ? other_expect[0].detail : "");
    }
  }, [dataDetail]);

  const getCountry = useCallback(async () => {
    try {
      const res = await getDropDownCountry();

      if (res.data.code === "0000") {
        let result_data = res.data.objectValue;
        setDropDownCountry(result_data);
      }
    } catch (error) {
      // console.log("error==>", error);
    }
  }, [dropDownCountry]);

  const getVOC = useCallback(
    async (toppicKey) => {
      const res = await getDropDownVOC(toppicKey);
      if (res.data.code === "0000") {
        let result_data = res.data.objectValue;

        if (toppicKey == "product_requirement") {
          setDropDownProductRequirement(result_data);
        } else if (toppicKey == "customer_support") {
          setDropDownCustomerSupport(result_data);
        } else if (toppicKey == "business_require") {
          setDropDownbusinessRequire(result_data);
        } else if (toppicKey == "customer_expect") {
          setDropDownCustomerExpact(result_data);
        } else if (toppicKey == "other_product_expect") {
          setDropDownotherProductExpect(result_data);
        } else if (toppicKey == "other_support_expect") {
          setDropDownSupportExpect(result_data);
        } else if (toppicKey == "other_business_expect") {
          setDropDownBusinessExpect(result_data);
        }

        if (toppicKey == "future_product_require") {
          setDropDownProductRequirement_v2(result_data);
        } else if (toppicKey == "future_customer_support") {
          setDropDownCustomerSupport_v2(result_data);
        } else if (toppicKey == "future_business_require") {
          setDropDownbusinessRequire_v2(result_data);
        } else if (toppicKey == "future_customer_expect") {
          setDropDownCustomerExpact_v2(result_data);
        } else if (toppicKey == "future_other_product_expect") {
          setDropDownotherProductExpect_v2(result_data);
        } else if (toppicKey == "future_other_support_expect") {
          setDropDownSupportExpect_v2(result_data);
        } else if (toppicKey == "future_other_business_expect") {
          setDropDownBusinessExpect_v2(result_data);
        }
      }
    },
    [dropDownVOC]
  );

  const getMaster = useCallback(
    async (toppicKey) => {
      try {
        const res = await getDropDownMaster(toppicKey);
        if (res.data.code === "0000") {
          let result_data = res.data.objectValue;

          if (toppicKey == "current_status") {
            setDropDownCurerntStatus(result_data);
          } else if (toppicKey == "current_status_v2") {
            setDropDownCurerntStatus_v2(result_data);
          } else if (toppicKey == "company_type") {
            setDropDownCompanyType(result_data);
          } else if (toppicKey == "industry_type") {
            setDropDownIndustryType(result_data);
          }else if (toppicKey == "future_industry_type") {
            setDropDownIndustryType_v2(result_data);
          } else if (toppicKey == "area_type") {
            setDropDownAreaType(result_data);
          } else if (toppicKey == "future_area_type") {
            setDropDownAreaType_v2(result_data);
          } else if (toppicKey == "known_channel") {
            setDropDownKnowChannel(result_data);
          } else if (toppicKey == "region_group") {
            setDropDownRegionGroup(result_data);
          } else if (toppicKey == "purpose_contact") {
            setDropDownPurpost(result_data);
          }else if (toppicKey == "region_type") {
            setDropDownRegionType(result_data);
          }
        }
      } catch (error) {
        // console.log("error==>", error);
      }
    },
    [dropDownMaster]
  );

  const toDataURL = (url) =>
    fetch(url)
      .then((response) => response.blob())
      .then(
        (blob) =>
          new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.onerror = reject;
            reader.readAsDataURL(blob);
          })
      );

  const DownloadFile = async (fileName) => {
    const res = await downloadFile(fileName);

    if (
      res.headers["content-type"] === "application/octet-stream" ||
      res.headers["content-type"] === "application/pdf"
    ) {
      // for pdf type
      const blobFile = new Blob([res.data], {
        type: "application/pdf",
      });
      const href = URL.createObjectURL(blobFile);
      const downloadLink = document.createElement("a");
      downloadLink.href = href;
      downloadLink.download = fileName;
      document.body.appendChild(downloadLink);
      downloadLink.click();
    } else {
      // for image type
      const { objectValue } = res.data;
      if (objectValue) {
        const href = `${
          "data:" + res.headers["content-type"] + ";base64," + objectValue.bytes
        }`;
        const downloadLink = document.createElement("a");
        downloadLink.href = href;
        downloadLink.download = objectValue.fileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
      }
    }
  };
  // state ไว้เก็บผลอัปโหลดทั้งหมด
    const [uploads, setUploads] = useState([]); 
    // uploads = [{ index: 0, fileName: 'a.png', filePath: '...'}, { index: 1, ... }]

    // helper: อัปเดต/แทนที่ตาม index
    const upsertUpload = (idx, fileName, filePath) => {
    setUploads(prev => {
        const existIdx = prev.findIndex(x => x.index === idx);
        const row = { index: idx, fileName, filePath };
        if (existIdx >= 0) {
        const next = prev.slice();
        next[existIdx] = row;
        return next;
        }
        return [...prev, row];
    });
    };

    // ดึง array เฉพาะ filePath (ไว้ส่งต่อ/บันทึก)
    const getAllFilePaths = () => uploads.map(x => x.filePath).filter(Boolean);
    // ดึง array ของ {fileName,filePath}
    const getAllFiles = () => uploads.map(({fileName, filePath}) => ({fileName, filePath}));
    const onUploadFile = async (info, index) => {
    const newObj = {
        index,
        file: info.file.name,
        name: info.file.name,
        status: "uploading",
        uid: info.file.uid,
        url: "",
        path: "",
    };

    const formData = new FormData();
    formData.append("file", info.file);

    const api = APIEndpoint.UPLOAD_FILE_API;
    const config = {
        headers: {
        Authorization: `Bearer ${localStorage.getItem("ACCESS_TOKEN")}`,
        "content-type": "multipart/form-data",
        },
    };

    const res = await axios.post(APPCONFIG.GATEWAY_ENDPOINT + api, formData, config);

    if (res?.data?.code === SUCCESS_CODE) {
        message.success(`${res.data.message}`);
        const { objectValue } = res.data;

        newObj.status = "done";
        newObj.file = objectValue.fileName;
        newObj.name = objectValue.fileName;
        newObj.path = objectValue.filePath;

        // === เพิ่มแค่บรรทัดนี้เพื่อเก็บ array ===
        upsertUpload(index, objectValue.fileName, objectValue.filePath);

        // ของเดิมคุณ
        if (fileList.length === 0) {
        setFileList([newObj]);
        } else {
        const newData = fileList.filter((item) => item.index !== index);
        newData.push(newObj);
        setFileList(newData);
        }
        form.setFields([
        { name: ["filePath", index], value: objectValue.filePath, errors: [] },
        ]);

        return newObj;
    } else {
        newObj.status = "error";
        message.error(`${res.data.message}`);
    }
    };

  const beforeUpload = (file) => {
    const okType = ["image/jpeg", "image/jpg", "application/pdf"].includes(file.type);
    if (!okType) {
      message.error("รองรับไฟล์ JPG/JPEG และ PDF เท่านั้น");
      return Upload.LIST_IGNORE;
    }
    const sizeOk = file.size / 1024 / 1024 <= 50;
    if (!sizeOk) {
      message.error("ขนาดไฟล์ต้องไม่เกิน 50 MB");
      return Upload.LIST_IGNORE;
    }
    return true;
  };
  const onPreviewFile = async (filePath) => {
    try {
      const res = await downloadFile(filePath);
      const { objectValue } = res.data || {};
      if (!objectValue?.bytes) throw new Error("no bytes");

      let type = objectValue.headers?.["Content-Type"]?.[0] || "application/octet-stream";
      // เผื่อเคส octet-stream แต่ชื่อ .pdf
      if (type === "application/octet-stream" && objectValue.fileName?.toLowerCase().endsWith(".pdf")) {
        type = "application/pdf";
      }
      const src = bytesToDataUrl(objectValue.bytes, type);
      setPreview({ visible: true, src, isPdf: type === "application/pdf", title: objectValue.fileName || "Preview" });
    } catch (e) {
      console.error(e);
      message.error("ไม่สามารถพรีวิวไฟล์ได้");
    }
  };
    const bytesToDataUrl = (bytes, contentType) => {
    // API เดิมคืน base64 อยู่แล้วใน objectValue.bytes (จากโค้ดที่คุณโชว์ก่อนหน้า)
    const base64 = Array.isArray(bytes)
      ? btoa(String.fromCharCode(...bytes))
      : bytes;
    return `data:${contentType};base64,${base64}`;
  };

  useEffect(() => {
    getDetail();
    getCountry();

    vocDataFuture.map((item) => {
      getVOC(item);
    });

    getMaster("current_status");
    getMaster("current_status_v2");
    getMaster("company_type");
    getMaster("industry_type");
    getMaster("future_industry_type");
    getMaster("area_type");
    getMaster("future_area_type")
    getMaster("known_channel");
    getMaster("region_group");
    getMaster("region_type");
    getMaster("purpose_contact");
  }, [location]);

  return (
    <WithSidebar>
      <div>
        <Row gutter={[24, 24]} style={{ marginTop: 15 }}>
          <Col span={24}>
            <div className="flex items-center">
              <Space size={12}>
                <Button
                  type="link"
                  onClick={() => {
                    setOpenCancelModal(true);
                    setPreviousPage(routes.customer_tab_future);
                  }}
                  style={{ padding: 0 }}
                >
                  <ArrowLeftOutlined style={{ color: "#000", fontSize: 16 }} />
                </Button>
                <Heading text={"รายละเอียด"} size={4} style={{ margin: 0 }} />
              </Space>
            </div>
            <Breadcrumb
              style={{ paddingTop: 10 }}
              items={[
                {
                  title: "คลังข้อมูลลูกค้าอนาคต",
                },
                {
                  title: (
                    <span onClick={onChangePage} style={{ cursor: "pointer" }}>
                      รายละเอียด
                    </span>
                  ),
                },
              ]}
            />
          </Col>

          <Col span={24}>
            <Form
              form={form}
              onFinish={onFinish}
              layout="vertical"
              autoComplete="off"
              style={{ width: "100%", padding: "0 30px" }}
            >
              <Row gutter={[24, 16]} style={{ marginBottom: 10 }}>
                {actionType === "EDIT" && (
                  <>
                    <Col span={24} align="right">
                      <Space>
                        <Button
                          type="primary"
                          onClick={() =>
                            navigate(routes.add_customer_future, {
                              state: {
                                id: id,
                                action_type: "EDIT",
                              },
                            })
                          }
                        >
                          แก้ไข
                        </Button>
                      </Space>
                    </Col>
                  </>
                )}
              </Row>
              {/* Future Deatil */}
              <FutureDetailView
                getYearDropdown={optionsYear}
                dataDetail={dataDetail}
                getCountry={dropDownCountry}
                dropDownAreaType={dropDownAreaType}
                dropDownAreaType_v2={dropDownAreaType_v2}
                dropDownCompanyType={dropDownCompanyType}
                dropDownCurerntStatus={dropDownCurerntStatus}
                dropDownCurerntStatus_v2 = {dropDownCurerntStatus_v2}
                dropDownIndustryType={dropDownIndustryType}
                dropDownIndustryType_v2={dropDownIndustryType_v2}
                dropDownKnowChannel={dropDownKnowChannel}
                dropDownPurpost={dropDownPurpost}
                dropDownRegionGroup={dropDownRegionGroup}
                dropDownRegionType={dropDownRegionType}
                countMonth={countMonth}
                onUploadFile={onUploadFile}
                onPreviewFile={onPreviewFile}
                beforeUpload={beforeUpload}
                preview={preview}
                setPreview={setPreview}

                fileImageList={fileImageList}
                setFileImageList={setFileImageList}
                slotIndex = {slotIndex}
                items = {items}
                thumbs = {thumbs}
              />

              {/* Voice of Customer */}
              <VoiceOfCustomerView
                dataDetail={dataDetail}
                dropDownproductRequirement={dropDownproductRequirement}
                dropDowncustomerSupport={dropDowncustomerSupport}
                dropDowncustomerExpact={dropDowncustomerExpact}
                dropDownbusinessRequire={dropDownbusinessRequire}
                dropDownotherProductExpect={dropDownotherProductExpect}
                dropDownotherSupportExpect={dropDownotherSupportExpect}
                dropDownotherBusinessExpect={dropDownotherBusinessExpect}
                productRequirement={productRequirement}
                customerSupport={customerSupport}
                customerExpact={customerExpact}
                businessRequire={businessRequire}
                otherProductExpect={otherProductExpect}
                otherSupportExpect={otherSupportExpect}
                otherBusinessExpect={otherBusinessExpect}
                otherExpect={otherExpect}

                dropDownproductRequirement_v2={dropDownproductRequirement_v2}
                dropDowncustomerSupport_v2={dropDowncustomerSupport_v2}
                dropDowncustomerExpact_v2={dropDowncustomerExpact_v2}
                dropDownbusinessRequire_v2={dropDownbusinessRequire_v2}
                dropDownotherProductExpect_v2={dropDownotherProductExpect_v2}
                dropDownotherSupportExpect_v2={dropDownotherSupportExpect_v2}
                dropDownotherBusinessExpect_v2={dropDownotherBusinessExpect_v2}
                productRequirement_v2={productRequirement_v2}
                customerSupport_v2={customerSupport_v2}
                customerExpact_v2={customerExpact_v2}
                businessRequire_v2={businessRequire_v2}
                otherProductExpect_v2={otherProductExpect_v2}
                otherSupportExpect_v2={otherSupportExpect_v2}
                otherBusinessExpect_v2={otherBusinessExpect_v2}
                otherExpect_v2={otherExpect_v2}
              />
              {/* Behavior */}
              <BehaviorView
                dataDetail={dataDetail}
                dropDownKnowChannel={dropDownKnowChannel}
              />
              {/* Contact */}
              <ContactView
                futureCustomerContacts={futureCustomerContacts}
                dropDownCurerntStatus={dropDownCurerntStatus}
                dropDownCurerntStatus_v2={dropDownCurerntStatus_v2}
                
                DownloadFile={DownloadFile}
              />
            </Form>
          </Col>
        </Row>
      </div>
      <FloatButton.BackTop
        className="custom-float-btn"
        icon={<ArrowUpOutlined style={{ color: "#fff" }} />}
        shape="square"
        style={{ backgroundColor: "#499D96 !important", color: "#fff" }}
      />
    </WithSidebar>
  );
};
